// src/components/ProductGrid.jsx
import ProductBlock from "./ProductBlock";


// Динамически загружаем изображения из папки
const imageContext = require.context("../../assets/img/Aurus/items", false, /\.(png|jpe?g|svg)$/);

const images = imageContext.keys().reduce((acc, path) => {
  const filename = path.replace("./", ""); // убираем './'
  acc[filename] = imageContext(path);
  return acc;
}, {});

const products = [
  {
    name: "Конвектор электрический AURUS ACH-1502 PF",
    link: "#",
    badges: ["Серия P"],
    colors: ["#d4d4d4", "#333333", "#fdffff"],
    images: ["item1_1.png", "item1_2.png", "item1_3.png"],
    characteristic: "Макс. потребляемая мощность: 1,5"
  },
  {
    name: "Сплит-система инверторного типа AURUS D DC ADI-09HN8/BLACK комплект",
    link: "#",
    badges: ["Серия D"],
    colors: ["#000000", "#b9ad5f"],
    images: ["item2_1.png", "item2_2.png"],
    characteristic: "Номинальная производительность охлаждения: 2.7"
  },
  {
    name: "Обогреватель инфракрасный AURUS AIH W 1000",
    link: "#",
    badges: ["Серия P"],
    colors: ["#d4d4d4"],
    images: ["item3.png"],
    characteristic: "Макс. потребляемая мощность: 1"
  }
];

const ProductGrid = () => {
  return (
    <section className="bp-block product-grid">
      <div className="wrapper">
        <h2 className="bp-header-h2">Новинки</h2>
        <div className="bp-block__container">
          {products.map((product, idx) => (
            <ProductBlock
              key={idx}
              product={{
                ...product,
                images: product.images.map(img => images[img]) // заменяем строки путей на импорты
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductGrid;
